<template>
  <div id="app">
    <form @submit.prevent="handleSubmit">
      <input v-model="firstName" placeholder="First Name">
      <input v-model="lastName" placeholder="Last Name">
      <div ref="form"/>
      <br/>
      <label><input type="checkbox" v-model="rawMode">"Raw" mode</label>
<br/>
      <button>Submit</button>
    </form>
  </div>
</template>

<script>
import { CCForm } from "./ou-payment-form";

export default {
  name: "app",
  data() {
    return {
      state: null,
      firstName: null,
      lastName: null,
      rawMode: false
    };
  },
  mounted() {
    this.form = new CCForm(this.$refs.form, { local: true, height: 90, noCVV: true });
    this.form.on("state", ({ state }) => {
      this.state = state;
    });
    window.form = this.form
    this.form.on('card', (card) => {
      console.log(card)
    })
  },
  watch: {
    rawMode () {
      //this.form.setRawMode(this.rawMode)
    }
  },
  methods: {
    async handleSubmit() {
      if (this.form.state !== "valid") return;

      try {
        const token = await this.form.createToken({
          FirstName: this.firstName,
          LastName: this.lastName,
          gateway: 'USAePay'
        }, true, this.rawMode);
  
        alert(JSON.stringify(token));

        this.form.reset()

      } catch (error) {
        alert(`Something has gone wrong ${error}`)
      }
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
